// fin-core / period — calendar months, as the screen asks for them. Pure; the clock is passed in.
//
// A month is `YYYY-MM`. The reporting period is the calendar month (operator, 2026-10-06), so the
// balance is read month by month.

const MONTH = /^(\d{4})-(0[1-9]|1[0-2])$/;

export const isMonth = (s: string): boolean => MONTH.test(s);

/** The first and last day of a month, both inclusive. */
export function monthRange(month: string): { from: string; to: string } {
  const m = MONTH.exec(month);
  if (!m) throw new RangeError(`monthRange: ${month} is not a YYYY-MM month`);
  const year = Number(m[1]);
  const mm = Number(m[2]);
  const last = new Date(Date.UTC(year, mm, 0)).getUTCDate();
  return { from: `${m[1]}-${m[2]}-01`, to: `${m[1]}-${m[2]}-${String(last).padStart(2, '0')}` };
}

/** `2026-12` shifted by +1 is `2027-01`; by −1 is `2026-11`. */
export function shiftMonth(month: string, delta: number): string {
  const m = MONTH.exec(month);
  if (!m) throw new RangeError(`shiftMonth: ${month} is not a YYYY-MM month`);
  const index = Number(m[1]) * 12 + (Number(m[2]) - 1) + delta;
  const year = Math.floor(index / 12);
  return `${year}-${String((index % 12) + 1).padStart(2, '0')}`;
}

/** Today's date in Paris (`YYYY-MM-DD`) at this instant, whatever the machine's own zone. */
export function todayParis(now: Date): string {
  const parts = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const get = (t: string) => parts.find((p) => p.type === t)?.value;
  return `${get('year')}-${get('month')}-${get('day')}`;
}

/** The month it is in Paris at this instant, whatever the machine's own zone. */
export function currentMonthParis(now: Date): string {
  const parts = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit' }).formatToParts(now);
  const year = parts.find((p) => p.type === 'year')?.value;
  const month = parts.find((p) => p.type === 'month')?.value;
  return `${year}-${month}`;
}

const MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

/** `2026-10` → `octobre 2026`. Anything that is not a month is returned as it is. */
export function formatMonthLong(month: string): string {
  const m = MONTH.exec(month);
  return m ? `${MONTHS[Number(m[2]) - 1]} ${m[1]}` : month;
}
